module.exports = __webpack_public_path__ + "img/ERIC_MISKA.caeedc40.png";